import React from "react";

export default function ModalCover() {
  return <div className="modal-cover" />;
}
